import { useState } from 'react';

function MailForwarderQuickCreateModal({ address, onClose, onUndo, undoing }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="cf-overlay">
      <div className="cf-modal mfr-quick-create-modal">
        <div className="cf-header">
          <h2>Forwarder Created</h2>
          <button className="cf-close" type="button" onClick={onClose}>✕</button>
        </div>

        <div className="cf-form">
          <label className="cf-label">Address</label>
          <div className="mfr-quick-create-address">
            <code>{address}</code>
            <button type="button" className="admin-btn-secondary" onClick={handleCopy}>
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>

          <div className="cf-actions">
            <button type="button" className="admin-btn-delete" disabled={undoing} onClick={onUndo}>
              {undoing ? 'Undoing…' : 'Undo'}
            </button>
            <button type="button" className="cf-btn-save" onClick={onClose}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MailForwarderQuickCreateModal;
